import { selector } from "recoil"
import { formReadyState, formReadyStateV2 } from "stores/form-ready"
import { tenantScreeningState, tenantScreeningStateV2 } from "stores/tenant-screening"
import { progressGenerator, progressGeneratorV2 } from "utils/progress-generator"


const selectProgressStep = selector({
  key: "selectProgressStep",
  get: ({ get }) => {
    return progressGenerator(get(tenantScreeningState), get(formReadyState))
  },
})

const selectProgressStepV2 = selector({
  key: "selectProgressStepV2",
  get: ({ get }) => {
    return progressGeneratorV2(get(tenantScreeningStateV2), get(formReadyState))
  },
})

export { selectProgressStep, selectProgressStepV2 }
